<script lang="ts">
  // What a multi-select list grows once its row buttons scroll off the top.
  // On a phone the "N selected / Approve / Reject" cluster in the toolbar is
  // 900px above the row you just ticked, so below `sm` the same cluster docks
  // to the bottom edge instead, where the thumb already is. Desktop keeps its
  // toolbar cluster (mobileOnly, the default) — a docked bar there would be a
  // second copy of an affordance that was never out of reach.
  import { X } from 'lucide-svelte';
  import type { Snippet } from 'svelte';

  const {
    count,
    onClear,
    actions,
    noun = 'selected',
    mobileOnly = true
  }: {
    count: number;
    onClear: () => void;
    /** The bulk actions themselves — the caller owns them, since only it
        knows which of them the current selection actually supports. */
    actions: Snippet;
    noun?: string;
    mobileOnly?: boolean;
  } = $props();
</script>

{#if count > 0}
  <div class="tym-selection-bar {mobileOnly ? 'sm:hidden' : ''}" role="region" aria-label="Selection actions">
    <div class="mx-auto flex max-w-[720px] items-center gap-2">
      <span class="tym-selection-count shrink-0" aria-live="polite">{count} {noun}</span>
      <div class="ml-auto flex min-w-0 items-center gap-2">
        {@render actions()}
      </div>
      <button
        type="button"
        class="tym-touch -mr-1 flex shrink-0 items-center justify-center rounded-lg px-2 py-2 text-dark-gray hover:text-navy"
        onclick={onClear}
        aria-label="Clear selection"
      >
        <X class="h-[18px] w-[18px]" />
      </button>
    </div>
  </div>
{/if}
